/* eslint-disable no-console */
import axios from 'axios';
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import { localStorageService } from './localStorage.service.js';

export const getBomLibrary = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY.GET_LIBRARY}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCategoryList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY.GET_CATEGORIES}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getUsers = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY.GET_USERS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBomLibraryById = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY.GET_LIBRARY_BY_ID}${data.bomLibId}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBomLibraryReferenceType = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY_FETCH_REFERENCE_TYPE.GET}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBomLibraryReferenceSupplier = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY_FETCH_REFERENCE_SUPPLIER.GET}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBomLibraryComposition = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY_FETCH_COMPOSITION.GET}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBomLibraryUnitOfMeasure = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY_FETCH_UNIT_OF_MEASURE.GET}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addBomLibrary = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.BOM_LIBRARY.GET_LIBRARY}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
  }
};

export const fetchBomLibrary = async (datas) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY.GET_LIBRARY}`, {
      params: { ...datas },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const removeBomLibrary = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.BOM_LIBRARY.GET_LIBRARY}`, { data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editBomLibrary = async (data, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.BOM_LIBRARY.GET_LIBRARY}/${id}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveBomSubTypes = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.BOM_LIBRARY.BOM_SUB_TYPE}`, { ...data });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const saveComponentSubTypes = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.BOM_LIBRARY.COMPONENT_SUB_TYPE}`, { ...data });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getColourDocs = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY.GET_COLOUR_DOCS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addBomLibraryTag = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.BOM_LIBRARY.ADD_BOM_LIBARARY_TAGS}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBomLibraryTag = async () => {
  try {
    return apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY.GET_BOM_LIBARARY_TAGS}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBomLibraryTagById = async (bomComponentId) => {
  try {
    return apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY.GET_BOM_LIBARARYBYID_TAGS}/${bomComponentId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchSuppliersFactoriesService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.BOM_LIBRARY_FETCH_REFERENCE_SUPPLIER.GET_SUPPLIER_FACTORIES}`, {
      suppliers: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const exportExcelService = async (data) => {
  try {
    const userInfo = localStorageService.get('loggedInUserInfo');
    if (userInfo) {
      const config = {
        headers: { Authorization: `Bearer ${userInfo.token}` },
        responseType: 'arraybuffer',
        params: { ...data },
      };
      return new Promise((resolve, reject) => {
        axios
          .get(`${apiEndpoint}${API.BOM_LIBRARY.DOWNLOAD_BOM_LIBRARY}/${data.bomTypeId}`, {
            ...config,
            withCredentials: true,
          })
          .then((response) => {
            const blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            resolve(blob);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const uploadBOMXlsxFileService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.BOM_LIBRARY.BOM_EXCEL_SHEET_IMPORT}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBomComponentSubType = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY.COMPONENT_SUB_TYPE}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBOMOptions = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY.GET_ALL_BOMS}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBomLibraryListNames = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY.GET_LIBRARY_NAME}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const bulkUpdateProductBomCosting = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_ATTRIBUTES.BULK_UPDATE_PRODUCT_BOM_COSTING}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
